import helpers from './../../helpers.js'
import _ from 'lodash'
import moment from 'moment'

export default {

    namespaced:true,

    state: {

        

    },// state

    getters: {

        getAll: (state,getters,rootState,rootGetters) => {
            return rootGetters.getAll('timelogs')
            if( !rootGetters.firebase_arrays.timelogs ) return []
            return rootGetters.firebase_arrays.timelogs
        },

        //getOne: (state,getters,rootState,rootGetters) => (key) =>  { for( let item of getters.getAll ) if( item.key === key ) return item },
        getOne: (state,getters,rootState,rootGetters) => (key) =>  { return rootGetters.getOne('timelog',key) },
        
        timelogs_timestamped(state,getters,rootState,rootGetters){
            //var output = {}
            //var output = rootState.firebase.timelogs
            //return output
        },

        getTotalHours: (state,getters,rootState,rootGetters) => (timelogs) => 
        {
          var hrs = 0
          for( let timelog of timelogs ) hrs += parseFloat(timelog.hours)
          return hrs          
        },

        getFiltered: (state,getters,rootState,rootGetters) => (filters, timelogs) => 
        {

            var output = []
            
            if( !timelogs ) timelogs = getters.getAll

            if( !timelogs ) return output

            if( !filters ) filters = {}
      
            for( let i = 0; i < timelogs.length; i++ ) {

              let timelog = timelogs[i]
      
              if( timelog.archived && !filters.include_archived ) continue
      
              if( filters.user_key != undefined && filters.user_key != 'undefined' ) {
                if( filters.user_key != timelog.user_key ) continue
              }
      
              if( filters.project_key !== undefined && filters.project_key !== timelog.project_key )  continue

              if( filters.project_keys != undefined ) {
                  if( filters.project_keys.indexOf(timelog.project_key) === -1 ) continue
              }
      
              if( filters.client_key != undefined && filters.client_key != 'undefined' ) {
                var timelog_client = rootGetters['clients/getClientByProjectKey'](timelog.project_key)
                if( !timelog_client ) continue                
                if( filters.client_key != timelog_client['.key'] ) continue
              }       
      
              if( filters.date_from_timestamp || filters.date_to_timestamp ) {    
                if( !timelog.date_timestamp ) console.log('timelog: converting time format')
                if( !timelog.date_timestamp ) timelogs[i].date_timestamp = moment(timelog.date,'YYYY-MM-DD').unix()
                var timelog = timelogs[i]
                if( timelog.date_timestamp < filters.date_from_timestamp ) continue
                if( timelog.date_timestamp > filters.date_to_timestamp ) continue          
              }

              if( filters.only_billable === true && timelog.billable !== true ) continue

              output.push(timelog)
      
            }
      
            if( !filters.no_sorting ) output = getters.sort_newest(output)

            helpers.log('Ran timelogs filtering: '+timelogs.length+' items')
      
            return output
          },

          //-------------------------------------------------------

          sort_newest: (state,getters,rootState,rootGetters) => (timelogs) => 
          {
            return timelogs.sort(function(a,b){
              return b.date_timestamp - a.date_timestamp
            })
          },

          //-------------------------------------------------------

          // experiment: should be faster than using getFiltered() again and agin
          // but doesn't help really. is slow one time first, since working all, and not much faster afterwards

          get_cached(state,getters,rootState,rootGetters){
            helpers.log('organizing and caching timelogs')
            var output = {
              client: {},
              project: {},
              user: {},
            }
            
            var clients = rootGetters['clients/getAll']
            var projects = rootGetters['projects/getAll']
            var users = rootGetters['users/getAll']

            for( let project of projects ) output.project[project.key] = []
            for( let user of users ) output.user[user.key] = []
            for( let client of clients ) output.client[client.key] = []

            for( let timelog of rootGetters.getAll('timelogs') ) {
              for( let project of projects ) if( timelog.project_key === project.key ) output.project[project.key].push(timelog)
              for( let user of users ) if( timelog.user_key === user.key ) output.user[user.key].push(timelog)
            }

            for( let client of clients ) {
              for( let project of projects ) {
                if( project.client_key === client.key ) {
                  output.client[client.key] = output.client[client.key].concat(output.project[project.key])
                }
              } 
            }           

            return output

          },

          //-------------------------------------------------------

          my_timelogs(state,getters,rootState,rootGetters){ return getters.get_cached.user[rootGetters['users/my_user_key']] },
		
          my_timelogs_this_week(state,getters,rootState,rootGetters){
            var timelogs = getters.getFiltered({
              date_from_timestamp: moment().subtract(7,'day').startOf('day').unix(),
                date_to_timestamp: moment().add(0,'day').endOf('day').unix(),
            }, getters.my_timelogs)
            return timelogs
          },

          my_timelogs_today(state,getters,rootState,rootGetters){
            var timelogs = getters.getFiltered({
              date_from_timestamp: moment().subtract(0,'day').startOf('day').unix(),
                date_to_timestamp: moment().add(0,'day').endOf('day').unix(),
            }, getters.my_timelogs_this_week)
            return timelogs
          },
          
          my_timelogs_yesterday(state,getters,rootState,rootGetters){
            var timelogs = getters.getFiltered({
              date_from_timestamp: moment().add(-1,'days').startOf('day').unix(),
                date_to_timestamp: moment().add(-1,'days').endOf('day').unix(),
            }, getters.my_timelogs_this_week)
            return timelogs
          },

          my_timelogs_today_hrs(state,getters,rootState,rootGetters){ return getters.getTotalHours(getters.my_timelogs_today) },
          my_timelogs_this_week_hrs(state,getters,rootState,rootGetters){ return getters.getTotalHours(getters.my_timelogs_this_week) },
          my_timelogs_yesterday_hrs(state,getters,rootState,rootGetters){ return getters.getTotalHours(getters.my_timelogs_yesterday) },

          //-------------------------------------------------------
        
    },// getters

    mutations: {

        

    },// mutations

}


// WEBPACK FOOTER //
// ./src/store/modules/timelogs.js